export const InterviewPromptIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path d="M1.5,21.5V9A1.5,1.5,0,0,1,3,7.5H19A1.5,1.5,0,0,1,20.5,9V21.5Z" fill="#00e6ca" />
      <path d="M14.438,7.5H3A1.5,1.5,0,0,0,1.5,9V20.438Z" fill="#c4f0eb" />
      <path
        d="M1.5,20.5V9A1.5,1.5,0,0,1,3,7.5h8.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M20.5,9.5v11" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path
        d="M13.5,20.5v1h-5v-1H.5v2a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1v-2Z"
        fill="#c4f0eb"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16,18.5c-.408-.63-1.761-1.088-3.455-1.715-.479-.178-.4-1.426-.188-1.659a3.532,3.532,0,0,0,.918-2.734A2.188,2.188,0,0,0,11.036,10,2.188,2.188,0,0,0,8.8,12.392a3.526,3.526,0,0,0,.919,2.734c.211.233.29,1.481-.188,1.659-1.7.627-3.048,1.085-3.455,1.715"
        fill="#f8fafc"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5,1.5l-2,.583V1.5a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5.833l2,.667Z"
        fill="#00e6ca"
      />
      <path d="M14.5.5a1,1,0,0,0-1,1v5a.983.983,0,0,0,.234.62L20.353.5Z" fill="#c4f0eb" />
      <path
        d="M23.5,1.5l-2,.583V1.5a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5.833l2,.667Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
